import ApiService from './ApiService'

export async function apiGetNoteSessions(data = {}) {
    return ApiService.fetchData({
        url: '/notes/sessions',
        method: 'post',
        data,
    })
}

export async function apiUpsertNoteSession(data) {
    return ApiService.fetchData({
        url: '/notes/session',
        method: 'post',
        data,
    })
}

export async function apiGetTimelineEntries(data) {
    return ApiService.fetchData({
        url: '/notes/entries',
        method: 'post',
        data,
    })
}

export async function apiUpsertTimelineEntry(data) {
    return ApiService.fetchData({
        url: '/notes/entry',
        method: 'post',
        data,
    })
}

export async function apiDeleteTimelineEntry(data) {
    return ApiService.fetchData({
        url: '/notes/entry/delete',
        method: 'post',
        data,
    })
}